import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const HurricaneTwisterIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox="0 0 17 20" fill="none" strokeWidth={'1.75'}>
      <path
        d="M14.3066 13.6171C13.4014 14.2287 11.6616 14.6428 9.66388 14.6428C8.40908 14.6428 7.25604 14.4794 6.34766 14.2064"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9777 18.6221C11.9958 18.6221 11.1384 18.0886 10.6797 17.2957"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.70313 4.69403C1.70312 5.12952 1.89183 5.56075 2.25848 5.96309C2.62512 6.36543 3.16251 6.73101 3.83998 7.03895C4.51745 7.34689 5.32172 7.59116 6.20687 7.75782C7.09202 7.92447 8.04073 8.01025 8.99881 8.01025C9.95689 8.01025 10.9056 7.92447 11.7907 7.75782C12.6759 7.59116 13.4802 7.34689 14.1576 7.03895C14.8351 6.73101 15.3725 6.36543 15.7391 5.96309C16.1058 5.56075 16.2945 5.12952 16.2945 4.69403C16.2945 3.81451 15.5258 2.97102 14.1576 2.34911C12.7894 1.72719 10.9337 1.37781 8.99881 1.37781C7.06387 1.37781 5.20819 1.72719 3.83998 2.34911C2.47178 2.97102 1.70313 3.81451 1.70313 4.69403Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2923 9.68762C14.0249 10.6682 11.6803 11.3265 8.99736 11.3265C6.90677 11.3265 5.02157 10.9268 3.69141 10.2863"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVG>
  )
}
